<template>
    <div class="header-search-wrap">
        <button class="header-search-open d-lg-none" type="button"></button>
        <div class="header-search">
            <button
                class="header-search-btn"
                type="submit"
                @click="handleSearch"
            ><img src="/img/svg/icons-search.svg" alt="">
            </button>
            <input
                type="search"
                class="header-search-txt"
                data-toggle="dropdown"
                id="dropdown-settings2"
                v-model="filters.search"
                @input="handleSearch"
            />
            <div class="dropdown-menu" aria-labelledby="dropdown-settings2">
                <div class="scrollbar">
                    <ul>
                        <li v-if="listOfUsers.length <= 0">
                            No found users
                        </li>
                        <li
                            v-else
                            v-for="user in listOfUsers"
                            :key="user.id"
                            @click="showUserPage(user.type, user.id)"
                        >{{user.name}} {{user.last_name}} - {{ user.type }}
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>

</template>


<script>
import CommonService from "../../../app/Modules/AppUser/resources/js/services/CommonService";
import _ from 'lodash';

export default {
    name: 'HeaderSearch',
    data() {
        return  {
            filters: {
                search: '',
            },
            listOfUsers: [],

        }
    },
    methods: {
        showUserPage(type, id) {
            if (type === 'admin') {
                window.location.href = `/master-admin/settings/users/${id}/update`
            } else if (type === 'master-admin') {
                this.$showErrorMessage('The main administrator\'s profile is not viewable')
                return
            } else {
                window.location.href = `/master-admin/applicants/${id}/show`
            }
        },
        delayedSearch: _.debounce(function() {
            this.getListOfUsers()
        }, 500),

        handleSearch() {
            this.delayedSearch();
        },
        async getListOfUsers() {
            try {
                const {data: response} = await CommonService.searchUser(this.filters)
                this.listOfUsers = response
            } catch (e) {
                this.$showErrorMessage('Please try again later','No search results found!')
            }
        },
    },

}


</script>


<style scoped>

</style>
